// v83 — reopen a drawer when the user comes Back to the page it was open on (after "Main profile →").
const R = { v: null };
export const markReturn = (kind, path, payload) => { R.v = { kind, path, payload }; };
export function takeReturn(kind, path) {
  const v = R.v;
  if (!v || v.kind !== kind || v.path !== path) return null;
  R.v = null;
  return v.payload;
}
export const mainPath = (id, unaff) => (unaff ? `/unaffiliated/${id}` : `/kol/${id}`);
export const MAIN_HINT = "Their main KOL Radar profile: videos, exchanges and promo history";
